import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { keepParams } from '@homamo/meadow-utils';
import Error from '../../common/ErrorMessage';
import AdminNav from '../../admin/AdminNav';

const RetailerNotFoundComponent = ({ id, displayError }) => {
  return (
    <>
      <AdminNav />
      <h1>404. Retailer not found</h1>
      <p>No retailer found with ID: {id}</p>
      <p>
        <Link to={keepParams('/retailers')}>Back to all retailers</Link>
      </p>
      {displayError && displayError.message && (
        <>
          <p>
            <small>
              The following information may be useful for technical support:
            </small>
          </p>
          <Error error={displayError} />
        </>
      )}
    </>
  );
};

RetailerNotFoundComponent.propTypes = {
  id: PropTypes.string.isRequired,
  displayError: PropTypes.shape({
    message: PropTypes.string,
  }),
};

RetailerNotFoundComponent.defaultProps = {
  displayError: {},
};

export default RetailerNotFoundComponent;
